import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LiveViewerComponent} from './live-viewer/live-viewer.component';
import {LiveMessageComponent} from './live-message/live-message.component';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {FullscreenOverlayContainer, OverlayContainer, OverlayModule} from '@angular/cdk/overlay';
import {MatCardModule} from '@angular/material/card';
import {CdkScrollableModule, ScrollingModule} from '@angular/cdk/scrolling';
import {ProductListComponent} from './product-list/product-list.component';
import {MatIconModule} from '@angular/material/icon';
import {TokenInterceptor} from './token.interceptor';
import {LiveSellerComponent} from './live-seller/live-seller.component';
import {LiveDashboardComponent} from './live-seller/live-dashboard/live-dashboard.component';
import {TabViewModule} from 'primeng/tabview';
import {CardModule} from 'primeng/card';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ButtonModule} from 'primeng/button';
import {InputTextModule} from 'primeng/inputtext';
import {RippleModule} from 'primeng/ripple';
import {TableModule} from 'primeng/table';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {FormsModule} from '@angular/forms';
import {DPlayerModule} from 'angular-dplayer';
import {LiveProductsComponent} from './live-seller/live-products/live-products.component';
import {AvatarModule} from 'primeng/avatar';
import {DialogModule} from 'primeng/dialog';
import {CheckboxModule} from 'primeng/checkbox';
import {TagModule} from 'primeng/tag';
import {TestLinkComponent} from './test-link/test-link.component';
import {LikeAnimationComponent} from './like-animation/like-animation.component';
import {LiveListRoomComponent} from './live-list-room/live-list-room.component';
import {PaginatorModule} from 'primeng/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { CategoryAutoCompleteComponent } from './shared/category-auto-complete.component'


@NgModule({
    declarations: [
        AppComponent,
        LiveViewerComponent,
        LiveMessageComponent,
        ProductListComponent,
        LiveSellerComponent,
        LiveDashboardComponent,
        LiveProductsComponent,
        TestLinkComponent,
        LikeAnimationComponent,
        LiveListRoomComponent,
        CategoryAutoCompleteComponent
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    CdkScrollableModule,
    ScrollingModule,
    OverlayModule,
    MatIconModule,
    TabViewModule,
    CardModule,
    FontAwesomeModule,
    ButtonModule,
    InputTextModule,
    RippleModule,
    FormsModule,
    DropdownModule,
    DPlayerModule.forRoot({ // Global config
      autoplay: true      // All player can autoplay by default
    }),
    FormsModule,
    TableModule,
    AvatarModule,
    DialogModule,
    CheckboxModule,
    AutoCompleteModule,
    TagModule,
      PaginatorModule
  ],
    providers: [
        {provide: OverlayContainer, useClass: FullscreenOverlayContainer},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
